import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoPinterest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.444 20.315a10 10 0 1 0 11.112-16.63 10 10 0 0 0-11.112 16.63M7.555 5.348a8 8 0 1 1 1.746 14.183l1.542-3.47q.105.093.218.18A3.7 3.7 0 0 0 13.25 17 4.72 4.72 0 0 0 18 12a6 6 0 0 0-6-6 6 6 0 0 0-5.64 8 1 1 0 1 0 1.88-.63 4 4 0 0 1 5.291-5.067 4 4 0 0 1 2.165 2.166A4 4 0 0 1 16 12a2.76 2.76 0 0 1-2.75 3 1.74 1.74 0 0 1-1.488-1.007l1.148-2.583a1.001 1.001 0 1 0-1.82-.82l-3.572 8.037a8 8 0 0 1 .037-13.279"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLogoPinterest;
